import styled from 'styled-components';

export const TitleContent = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  margin: 2rem 0rem;
`;

export const Title = styled.h1`
  font-size: 30px;
  color: ${props => props.theme.textColor};
  font-weight: 700;
  text-transform: uppercase;
  pointer-events: none;
  user-select: none;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

export const SubTitle = styled.h2`
  color: ${props => props.theme.primaryColor};
  font-weight: 600;
  font-size: 1.25rem;
  margin-top: 1.5rem;
  pointer-events: none;
  user-select: none;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin: 6rem 0rem;

  a {
    width: 100%;
    margin: 1rem auto;

    button {
      width: 100%;
    }
  }

  @media (max-width: 992px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    margin: 3rem 0rem;
  }
`;
